export default __webpack_public_path__ + "static/media/bg-smart-home-1.054a67d0.jpg";